import React, { useState } from 'react';
import './exportdropdown.scss';
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../../const/resource';

const Dropdownwithsearch = (props: any) => {
    const { t } = useTranslation();

    const [showExport, setshowExport] = useState<boolean>(false);

    const toggleExport = () => {
        setshowExport(!showExport);
    };

    const onExcelExport = () => {
        setshowExport(!showExport);
        props?.excelExport();
    };

    return (
        <>
            <div className='excelExportTab'>
                <button
                    className={`exportMiningsecbtn ${props?.className}`}
                    title={t(RESOURCE.MyK_Label_Export)}
                    onClick={toggleExport}
                >
                    {t(RESOURCE.MyK_Label_Export)}
                    {showExport ? (
                        <span
                            className="fa fa-angle-up ml-1 ExportArrow"
                            aria-hidden="true"
                        ></span>
                    ) : (
                        <span
                            className="fa fa-angle-down ml-1 ExportArrow"
                            aria-hidden="true"
                        ></span>
                    )}

                </button>
                {showExport ? (
                    <div className="CustomNoneSelectDropdown">
                        <div
                            className="exportChild"
                            onClick={onExcelExport}
                            onKeyDown={() => { }}
                            title={t(RESOURCE.MyK_Label_ExportExcel)}
                        >
                            {t(RESOURCE.MyK_Label_ExportExcel)}
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    )
}

export default Dropdownwithsearch;
